import { t } from "@lingui/macro"
import { useMemo } from "react"

import { QuestionStack } from "./styled"

import { FormPanel } from "src/components/FormPanel"
import { QuestionsConfigSection } from "src/modals/polls/sections/QuestionConfig"
import { PollSettingsSection } from "src/modals/polls/sections/Settings"

import { EModalMode } from "src/types/modal/modal"
import { IQuestionsTabProps } from "src/modals/polls/types"

export const QuestionsTab = ({ mode }: IQuestionsTabProps) => {
    const isViewMode = useMemo(() => mode === EModalMode.View, [mode])

    return (
        <QuestionStack spacing={2}>
            <FormPanel
                sections={[
                    {
                        header: t`poll.settings-section.header`,
                        content: (
                            <PollSettingsSection isViewMode={isViewMode} />
                        ),
                    },
                ]}
            />
            <FormPanel
                sections={[
                    {
                        header: t`poll.question-config.header`,
                        content: (
                            <QuestionsConfigSection isViewMode={isViewMode} />
                        ),
                    },
                ]}
            />
        </QuestionStack>
    )
}
